// Orientation detection hook.
// Returns: "portrait" | "landscape-left" | "landscape-right"
//   - landscape-left: phone tilted CCW (top of phone goes left); user wants shutter RIGHT
//   - landscape-right: phone tilted CW (top of phone goes right); user wants shutter LEFT

import { useEffect, useState } from "react";

function compute() {
  if (typeof window === "undefined") return "portrait";
  // Prefer the Screen Orientation API
  const so = window.screen && window.screen.orientation;
  if (so && so.type) {
    if (so.type === "landscape-primary") return "landscape-left";
    if (so.type === "landscape-secondary") return "landscape-right";
    return "portrait";
  }
  // Legacy fallback (iOS old): window.orientation
  if (typeof window.orientation === "number") {
    if (window.orientation === 90) return "landscape-left";
    if (window.orientation === -90 || window.orientation === 270)
      return "landscape-right";
    return "portrait";
  }
  // Final fallback: aspect ratio
  if (window.innerWidth > window.innerHeight) return "landscape-left";
  return "portrait";
}

export function useOrientation() {
  const [orientation, setOrientation] = useState(compute);

  useEffect(() => {
    const update = () => setOrientation(compute());
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    const so = window.screen && window.screen.orientation;
    if (so && so.addEventListener) {
      so.addEventListener("change", update);
    }
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      if (so && so.removeEventListener) {
        so.removeEventListener("change", update);
      }
    };
  }, []);

  return orientation;
}
